import Button from "@mui/material/Button";
import ListItemIcon from "@mui/material/ListItemIcon";
import MenuItem from "@mui/material/MenuItem";
import LinkIcon from "@mui/icons-material/Link";
import { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ListItemText from "@mui/material/ListItemText";
import { URL_APP_VIEW_ALL_DOMAINS } from "../../../data/URLs";

type MyDomainsListButtonProps = {
  className?: string;
  mobile: boolean;
};

const MyDomainsListButton: FC<MyDomainsListButtonProps> = ({
  className,
  mobile,
}) => {
  const Navigate = useNavigate();
  const Location = useLocation();
  const highlight = Location.pathname === URL_APP_VIEW_ALL_DOMAINS;
  const onClick = () => {
    Navigate(URL_APP_VIEW_ALL_DOMAINS);
  };

  if (mobile) {
    return (
      <MenuItem
        sx={{ p: 2 }}
        selected={highlight}
        className={className}
        onClick={onClick}
      >
        <ListItemIcon>
          <LinkIcon />
        </ListItemIcon>
        <ListItemText>My Domains</ListItemText>
      </MenuItem>
    );
  }

  return (
    <Button
      className={className}
      variant="text"
      color={highlight ? "primary" : "inherit"}
      onClick={onClick}
    >
      <strong>My Domains</strong>
    </Button>
  );
};

export default MyDomainsListButton;
